/**
 * Shared MenuProps for MUI Select so dropdowns open consistently across the app:
 * - Rendered in portal (not clipped by parent overflow)
 * - High z-index so menu appears on top
 * - Short max height so the list stays within the dropdown and doesn't overlap the next form field
 * - Opens below the field (anchorOrigin/transformOrigin)
 */
const DROPDOWN_MAX_HEIGHT = 220;

const buildSelectMenuProps = (zIndex = 9999) => ({
  disablePortal: false,
  style: { zIndex },
  PopperProps: {
    modifiers: [{ name: "offset", options: { offset: [0, -4] } }],
    sx: { zIndex },
  },
  PaperProps: {
    style: {
      maxHeight: DROPDOWN_MAX_HEIGHT,
      overflow: "hidden",
      zIndex,
      border: "1px solid rgba(0,0,0,0.12)",
      borderRadius: 4,
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    },
  },
  MenuListProps: { style: { maxHeight: DROPDOWN_MAX_HEIGHT, overflowY: "auto" } },
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
});

export const selectMenuProps = buildSelectMenuProps(9999);

/** Use inside Create/Edit notification dialog (dialog z-index is 10001). */
export const inAppNotificationDialogMenuProps = buildSelectMenuProps(10005);
